import { type TRenderScrollableRow } from "src/components/shared/ScrollableTable/ScrollableTableRow";

import ClientRow from "../Clients/ClientRow";
import OrganizationsRow from "../Organization/OrganizationsRow";
import FleetYachtsRow from "../Yachts/FleetYachtsRow";
import YachtsRow from "../Yachts/YachtsRow";
import AdminsRow from "./AdminsRow";
import SubsRow from "./SubsRow/SubsRow";
import SubsRowWithClient from "./SubsRow/SubsRowWithClient";
import UsersRow from "./UsersRow";

interface ITableDataSection {
  headers: Array<{ label: string; name?: string }>;
  renderRow: TRenderScrollableRow<any>;
}

type TTableData = Record<string, ITableDataSection>;

export const getStatus = (active: string | number) =>
  active === "Yes" || active === 1 ? "Active" : "Archived";

export const tableData: TTableData = {
  _api: {
    headers: [
      { label: "Client" },
      { label: "Key" },
      { label: "Description" },
      { label: "Active" },
    ],
    renderRow: [],
  },
  _permissions: {
    headers: [
      { label: "Cat" },
      { label: "Sub Cat" },
      { label: "Perm" },
      { label: "Name" },
      { label: "Description" },
    ],
    renderRow: ["cat", "subcat", "perm", "name", "description"],
  },
  _logbooks: {
    headers: [
      { label: "Name" },
      { label: "Client" },
      { label: "Description" },
      { label: "Version" },
      { label: "Active" },
    ],
    renderRow: [
      "lbname",
      "clientname",
      "description",
      { value: "version", tdProps: { center: true } },
      { value: "active", tdProps: { center: true } },
    ],
  },
  _usertypes: {
    headers: [{ label: "Name" }, { label: "Description" }, { label: "Data" }],
    renderRow: ["name", "description", "data"],
  },
  _roles: {
    headers: [
      { label: "Usertype", name: "usertype" },
      { label: "Client", name: "client" },
      { label: "Yacht", name: "yacht" },
      { label: "Rolename", name: "rolename" },
      { label: "Description", name: "description" },
    ],
    renderRow: [
      "usertype",
      { value: "clientid", tdProps: { center: true } },
      { value: "yachtid", tdProps: { center: true } },
      "rolename",
      "description",
    ],
  },
  _subscriptions: {
    headers: [
      { label: "Client" },
      { label: "Yacht" },
      { label: "Logbook" },
      { label: "Type" },
      { label: "Start" },
      { label: "End" },
      { label: "Active" },
    ],
    renderRow: SubsRowWithClient,
  },
  _yachtSubscriptions: {
    headers: [
      { label: "Logbook" },
      { label: "Type" },
      { label: "Start" },
      { label: "End" },
      { label: "Active" },
    ],
    renderRow: SubsRow,
  },
  _users: {
    headers: [
      { label: "Client" },
      { label: "Yacht" },
      { label: "First Name" },
      { label: "Surname" },
      { label: "Ref" },
      { label: "Role" },
      { label: "Email" },
      { label: "Active" },
    ],
    renderRow: UsersRow,
  },
  _clients: {
    headers: [{ label: "Client Name" }, { label: "Yachts" }, { label: "" }],
    renderRow: ClientRow,
  },
  _organizations: {
    headers: [
      { label: "Organization Name" },
      { label: "Yachts" },
      { label: "Status" },
      { label: "" },
    ],
    renderRow: OrganizationsRow,
  },
  _yachts: {
    headers: [
      { label: "Yacht Name" },
      { label: "Open entries" },
      { label: "Status" },
      { label: "" },
    ],
    renderRow: YachtsRow,
  },
  _fleet_yachts: {
    headers: [
      { label: "Yacht Name" },
      { label: "Account Manager" },
      { label: "Subscription start" },
      { label: "Last accessed" },
      { label: "Open entries" },
      { label: "Status" },
      { label: "" },
    ],
    renderRow: FleetYachtsRow,
  },

  _admins: {
    headers: [
      { label: "First name" },
      { label: "Surname" },
      { label: "Email" },
      { label: "Phone no" },
      { label: "Mobile" },
      { label: "Active" },
    ],
    renderRow: AdminsRow,
  },
};
